<template>
  <div class="app-container">
    <PurchaseViewForm :list="list" complete-name="BusinessPurchaseApply" />
  </div>
</template>
<script>
import PurchaseViewForm from '@/views/center-business/purchase/components/PurchaseViewForm.vue';
export default {
  name: 'BusinessPurchaseApplyChangePurchase',
  components: { PurchaseViewForm },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    this.list = JSON.parse(localStorage.getItem('BusinessPurchaseApplyChangePurchaseList'));
  },
  mounted() {},
  methods: {},
};
</script>
